import React, {useCallback, useEffect, useState} from "react";
import {useDropzone} from "react-dropzone";
import ArrowWhiteUp from "../../Shared/icons/ArrowWhiteUp";
import classnames from "classnames";

function Dropzone(props) {
    const name = props.name;
    const text = props.text;
    const buttonText = props.buttonText;
    const removeText = props.removeText;
    const invalid = props.invalid;
    const errors = props.errors;

    const [myFiles, setMyFiles] = useState([]);
    const {setFieldValue} = props;
    const {getRootProps, getInputProps, acceptedFiles} = useDropzone({
        accept: {
            'image/jpeg': ['.jpeg', '.jpg'],
            'image/png': ['.png'],
            'application/pdf': ['.pdf'],
            'application/msword': ['.doc'],
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
        },
        onDrop: useCallback(acceptedFiles => {
            setMyFiles([...myFiles, ...acceptedFiles]);

        }, [myFiles]),
    });

    const removeFile = file => () => {
        const newFiles = [...myFiles];
        newFiles.splice(newFiles.indexOf(file), 1);
        setMyFiles(newFiles);
    };

    useEffect(() => {
        setFieldValue("files", myFiles);
    }, [myFiles]);

    return (
        <div>
            <div>
                {text &&
                    <div className="font-weight-bold text-secondary">
                        {text}
                    </div>
                }
            </div>

            <div>
                {myFiles &&
                    <ul className="job-opportunity-files">
                        {
                            myFiles.map(file => (
                                <li key={file.path} className={classnames("job-opportunity-files__item", {
                                    "is-invalid": invalid,
                                })}>
                                    {file.path}

                                    {removeText &&
                                        <button type="button" onClick={removeFile(file)}>{removeText}</button>
                                    }
                                </li>
                            ))
                        }
                    </ul>
                }

                {buttonText &&
                    <div {...getRootProps({className: "dropzone"})}>
                        <input name={name} {...getInputProps()} />

                        <div className="mt-8">
                            <button type="button"
                                    className={classnames("job-opportunity-files__button w-auto btn btn-primary justify-content-between d-inline-flex", {
                                        "is-invalid": myFiles.length < 1 && errors,
                                    })}>
                                <span className="">{buttonText}</span>

                                <div className="btn-arrow job-opportunity-files__button">
                                    {myFiles.length < 1 && errors ?
                                        <div className="btn-arrow">
                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                 viewBox="0 0 512 512">
                                                <path
                                                    d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32z"/>
                                            </svg>
                                        </div>
                                        :
                                        <ArrowWhiteUp/>
                                    }
                                </div>
                            </button>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
};

export default Dropzone;